import Image from 'next/image';
import { PLATFORM_V2_HERO_CONTENT } from '@/shared/constants/platform-pages-constants';
import './index.less';

const PlatformV2Hero = () => {
  return (
    <div className="platform-v2-hero-wrap">
      {PLATFORM_V2_HERO_CONTENT.map((item, index) => (
        <div className="platform-v2-hero-item-wrap" key={`platform-v2-hero-item-${index}`}>
          <div className="platform-v2-hero-item-image">
            <Image src={item.image} fill alt={item.title} />
          </div>
          <div className="platform-v2-hero-item-title">{item.title}</div>
          <div className="platform-v2-hero-item-subtitle">{item.subtitle}</div>
        </div>
      ))}
    </div>
  );
};
export default PlatformV2Hero;
